export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Home-Gray-71b2671ed35333c8aea68c7874a3cf9d.svg";